import { sum } from 'lib/array/arrayUtils'
import React, { createContext, PropsWithChildren } from 'react'

type CSSVar = `--${string}`

export const APP_HEADER_OFFSET_CSS_VAR: CSSVar = '--app-header-offset'

export type AppHeaderSection =
  | 'primary-header'
  | 'tertiary-header'
  | 'contact-options-banner'
  | 'notification-banner'
  | 'banners-stack'

type AppHeaderObserver = (section: AppHeaderSection, rect: DOMRect | undefined) => void

const observedHeights: Record<AppHeaderSection, number> = {
  'primary-header': 0,
  'tertiary-header': 0,
  'contact-options-banner': 0,
  'notification-banner': 0,
  'banners-stack': 0,
}

const appHeaderHandler: AppHeaderObserver = (section, rect) => {
  const height = rect?.height ?? 0
  observedHeights[section] = height
  document.documentElement.style.setProperty(APP_HEADER_OFFSET_CSS_VAR, `${sum(Object.values(observedHeights))}px`)
}

const AppHeaderContext = createContext<AppHeaderObserver>(appHeaderHandler)

export function AppHeaderContextProvider(props: PropsWithChildren) {
  return <AppHeaderContext.Provider {...props} value={appHeaderHandler} />
}

export default AppHeaderContext
